export default "__VITE_ASSET__CCX5DHzr__"